import { Logo } from "./Logo";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="bg-urban-teal text-white/80 mt-20">
    <div className="max-w-7xl mx-auto px-6 py-14 grid gap-8 md:grid-cols-4">
      <div>
        <Logo light />
        <p className="mt-4 text-sm max-w-xs">L'annuaire n°1 pour les foodtrucks. Trouvez qui cuisine près de vous, maintenant.</p>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <span className="font-display font-bold text-white mb-1">Explorer</span>
        <Link to="/recherche" className="hover:text-street-gold">Rechercher un foodtruck</Link>
        <Link to="/marches" className="hover:text-street-gold">Marchés & événements</Link>
        <Link to="/tarifs" className="hover:text-street-gold">Nos offres</Link>
        <Link to="/connexion?tab=signup" className="hover:text-street-gold">Référencer mon foodtruck</Link>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <span className="font-display font-bold text-white mb-1">Gérants</span>
        <Link to="/connexion" className="hover:text-street-gold">Se connecter</Link>
        <Link to="/dashboard" className="hover:text-street-gold">Mon espace pro</Link>
      </div>
      <div className="flex flex-col gap-2 text-sm">
        <span className="font-display font-bold text-white mb-1">Légal</span>
        <Link to="/mentions-legales" className="hover:text-street-gold" data-testid="footer-mentions-legales">Mentions légales</Link>
        <Link to="/cgu" className="hover:text-street-gold" data-testid="footer-cgu">CGU / CGV</Link>
        <Link to="/confidentialite" className="hover:text-street-gold" data-testid="footer-confidentialite">Politique de confidentialité</Link>
      </div>
    </div>
    <div className="border-t border-white/10 py-5 text-center text-xs text-white/50">© 2026 StreatEat - Fait avec passion pour la street food.</div>
  </footer>
);
